module.exports = __webpack_public_path__ + "images/rich_heading/small_appliance/smart_watch/icon_6a0fe2df8beef2f9a338394025e2404b.png";